// Port of api/fuel/app/classes/filter/search/games/sorts/query/play/location.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'play.location',
	post: false,
	require: function(config, filter) { return sorted('play.location', filter) > 0 },
	run: function(config, filter, data, query) {
		query.where('p.play_location', '<>', '')
		query.order('p.play_location', sortReverse('play.location', filter), sortPriority('play.location', filter))
	}
}
